import React from "react";
import ListView from "../components/Entity/ListView";

const columns = [
    {
        title: "ИД",
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: "Название",
        dataIndex: 'title',
        key: 'title',
    },
    {
        title: "Путь",
        dataIndex: 'path',
        key: 'path',
        // type: 'autocomplete',
        // getOptions: ({dataIn}) => (dataIn || [])
    },
    {
        title: "Число элемнтов",
        dataIndex: 'id',
        key: 'cnt',
        render: (text, record) => record.dashboardItems?.length || 0,
        noEditor: true
    },
    {
        title: "Описание",
        dataIndex: 'description',
        key: 'description',
        type: 'textarea'
    }
]

const customActions = [
    {
        title: "Отрыть WD",
        href: (idx) => `/wd/${idx}`
    }
]

const editor = [
    ...columns.filter(column => !column.noEditor)
]

const WdAdminPage = () =>
    <>
        <ListView
            config={{
                getAll: {method: 'GET', url: '/api/wd/all'},
                getOne: {method: 'GET', url: ({idx}) => `/api/wd/wd/${idx}`},
                postOne: {method: 'POST', url: ({idx}) => `/api/wd/wd/${idx}`},
                deleteOne: {method: 'DELETE', url: ({idx}) => `/api/wd/wd/${idx}`},
                idx: 'id',
                title: 'Дэшборды'
            }}
            columns={columns}
            editor={editor}
            customActions={customActions}/>
    </>

export default WdAdminPage